// Copyright 2020 The Nakama Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export interface ChatMessage {
  message_id: string;
  channel_id: string;
  channel_label?: string;
  code: number;
  sender_id: string;
  username?: string;
  content: string;
  create_time: string;
  update_time: string;
  persistent: boolean;
  room_name?: string;
  group_id?: string;
  user_id_one?: string;
  user_id_two?: string;
}

export interface ChatMessageList {
  messages: ChatMessage[];
  next_cursor?: string;
  prev_cursor?: string;
  cacheable_cursor?: string;
}

export interface ChatChannel {
  id: string;
  presences: ChatChannelPresence[];
  self: ChatChannelPresence;
  room_name?: string;
  group_id?: string;
  user_id_one?: string;
  user_id_two?: string;
}

export interface ChatChannelPresence {
  user_id: string;
  session_id: string;
  username?: string;
  node_id?: string;
}

export interface ChatMessageSearchFilters {
  channel_id?: string;
  sender_id?: string;
  username?: string;
  content?: string;
  room_name?: string;
  group_id?: string;
  code?: number;
  persistent?: boolean;
  type?: number;
  label?: string;
}

export interface DeleteChatMessageRequest {
  message_id: string;
  channel_id: string;
}

export interface UpdateChatMessageRequest {
  message_id: string;
  channel_id: string;
  content: string;
}

export interface SendChatMessageRequest {
  channel_id: string;
  content: string;
  sender_id?: string;
  username?: string;
  persistent?: boolean;
}

export enum ChatMessageCode {
  CHANNEL_JOIN = 0,
  CHANNEL_LEAVE = 1,
  CHANNEL_MESSAGE = 2,
  CHANNEL_UPDATE = 3,
  CHANNEL_REMOVE = 4
}

export interface ChatHistory {
  channel_id: string;
  messages: ChatMessage[];
  next_cursor?: string;
  prev_cursor?: string;
  cacheable_cursor?: string;
}

export interface ChatChannelList {
  channels: ChatChannel[];
  cursor?: string;
}

export interface ChatChannelSearchFilters {
  room_name?: string;
  group_id?: string;
  user_id?: string;
}
